import { PatientInformation, Data, IAQualityControl } from '../../components'
import { SessionExpired } from '../../components/SessionExpired'
import { useSelector } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  PatientContainer,
  ReportWrapper
} from './styles'

export const PatientReport = () => {
  const { evaluations, user } = useSelector(state => state)
  const isPatient = user.role === 'patient'

  if (isPatient) {
    return <Redirect to='/new-report?mode=readonly' />
  }

  // Combina informInfo con idInstitucion, fecha, requiere_recaptura y estado si es oftalmólogo
  const studyData = isPatient
    ? evaluations
    : { ...evaluations.informInfo, idInstitucion: evaluations.idInstitucion, fecha: evaluations.fecha, requiere_recaptura: evaluations.requiere_recaptura, estado: evaluations.estado }

  const patientData = isPatient
    ? user.data
    : evaluations.patientInfo

  return (
    <PatientContainer>
      <SessionExpired />
      <PatientInformation study={evaluations} patientData={patientData} withEvaluationsButton />
      <ReportWrapper>
        <Data study={studyData} patientData={patientData} />
        <IAQualityControl study={evaluations} />
      </ReportWrapper>
    </PatientContainer>
  )
}
